import Content from './Content/Content';
import { SideMenu } from './SideMenu';

import type { ReactElement } from 'react';

interface Props {
  children: ReactElement;
}

const Layout = ({ children }: Props) => (
  <>
    <SideMenu />
    <Content>
      {children}
    </Content>
  </>
);

export default Layout;
